// Shared helpers for challenge due dates.
export function dueInfo(due) {
  if (!due) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(`${due}T00:00:00`);
  if (isNaN(d.getTime())) return null;
  const diff = Math.round((d - today) / 86400000);
  if (diff < 0) return { label: `Overdue by ${Math.abs(diff)}d`, tone: "risk", days: diff };
  if (diff === 0) return { label: "Due today", tone: "watch", days: 0 };
  if (diff === 1) return { label: "1 day left", tone: "watch", days: 1 };
  return { label: `${diff} days left`, tone: diff <= 3 ? "watch" : "neutral", days: diff };
}
